import axios from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type {
  CheckoutAttemptStatus,
  CheckoutDeliveryFeeInput,
  CheckoutDeliveryFeeResponse,
} from './checkout.types'

export interface CheckoutAttemptStatusRequest {
  organizationId: OrganizationId
  attemptId?: number | string | null | undefined
}

interface CheckoutDeliveryFeeRequest {
  organizationId: OrganizationId
  cartId: number | string
  data: CheckoutDeliveryFeeInput
}

export async function getCheckoutAttemptStatus({
  organizationId,
  attemptId,
}: CheckoutAttemptStatusRequest): Promise<CheckoutAttemptStatus> {
  return axios.get<CheckoutAttemptStatus>(
    `/checkout/attempts/${attemptId}/status`,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function calculateCheckoutDeliveryFee({
  organizationId,
  cartId,
  data,
}: CheckoutDeliveryFeeRequest): Promise<CheckoutDeliveryFeeResponse> {
  return axios.post<CheckoutDeliveryFeeResponse>(
    `/checkout/${cartId}/calculate-delivery-fee`,
    data,
    buildAdminRequestConfig({ organizationId })
  )
}
